import _regeneratorRuntime from "/workspace/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/workspace/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/node_modules/@babel/runtime/helpers/esm/createClass";
import TransactionIntent from '../transactions/TransactionIntent';
import { toArrayEntry } from '../utils/misc';

function normalizeAppFilters(filters) {
  var _a;

  if (!filters) {
    return {};
  }

  if (typeof filters === 'string') {
    return filters.startsWith('0x') ? {
      address: [filters]
    } : {
      name: [filters]
    };
  }

  if (Array.isArray(filters)) {
    return ((_a = filters[0]) === null || _a === void 0 ? void 0 : _a.startsWith('0x')) ? {
      address: filters
    } : {
      name: filters
    };
  }

  if (filters.address) {
    return {
      address: toArrayEntry(filters.address)
    };
  }

  if (filters.name) {
    return {
      name: toArrayEntry(filters.name)
    };
  }

  return {};
}

var Organization =
/*#__PURE__*/
function () {
  function Organization(connection) {
    _classCallCheck(this, Organization);

    this.connection = connection;
  }

  _createClass(Organization, [{
    key: "app",
    ///////// APPS ///////////
    value: function () {
      var _app = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(filters) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.connection.orgConnector.appForOrg(this, normalizeAppFilters(filters)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function app(_x) {
        return _app.apply(this, arguments);
      }

      return app;
    }()
  }, {
    key: "apps",
    value: function () {
      var _apps = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(filters) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.connection.orgConnector.appsForOrg(this, normalizeAppFilters(filters)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function apps(_x2) {
        return _apps.apply(this, arguments);
      }

      return apps;
    }()
  }, {
    key: "onApp",
    value: function onApp(filtersOrCallback, callback) {
      var filters = callback ? filtersOrCallback : null;

      var _callback = callback || filtersOrCallback;

      return this.connection.orgConnector.onAppForOrg(this, normalizeAppFilters(filters), _callback);
    }
  }, {
    key: "onApps",
    value: function onApps(filtersOrCallback, callback) {
      var filters = callback ? filtersOrCallback : null;

      var _callback = callback || filtersOrCallback;

      return this.connection.orgConnector.onAppsForOrg(this, normalizeAppFilters(filters), _callback);
    } ///////// PERMISSIONS ///////////

  }, {
    key: "permissions",
    value: function () {
      var _permissions = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.connection.orgConnector.permissionsForOrg(this));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function permissions() {
        return _permissions.apply(this, arguments);
      }

      return permissions;
    }()
  }, {
    key: "onPermissions",
    value: function onPermissions(callback) {
      return this.connection.orgConnector.onPermissionsForOrg(this, callback);
    } ///////// INTENTS ///////////

  }, {
    key: "appIntent",
    value: function appIntent(appAddress, functionName, functionArgs) {
      return new TransactionIntent({
        contractAddress: appAddress,
        functionName: functionName,
        functionArgs: functionArgs
      }, this, this.connection.ethersProvider);
    }
  }, {
    key: "location",
    get: function get() {
      return this.connection.orgLocation;
    }
  }, {
    key: "address",
    get: function get() {
      return this.connection.orgAddress;
    }
  }, {
    key: "_connection",
    get: function get() {
      return this.connection;
    }
  }]);

  return Organization;
}();

export { Organization as default };